
export interface PhoneNumberCode {
    code: string
    en: string // English country name
    es: string // Spanish country name
}

export interface Country {
    name: string,
    id: string
}

// NOTE this follows the structure required by SelectAdvanced and uses the 2 digit country codes
export const COUNTRIES: { [key: string]: Country }  = {
    "PE": { name: "Perú", id: "PE" },
    "CO": { name: "Colombia", id: "CO" },
    // "US": { name: "United States", id: "US" },
    "BR": { name: "Brazil", id: "BR" },
    "MX": { name: "Mexico", id: "MX" },
    "AR": { name: "Argentina", id: "AR" },
    "CL": { name: "Chile", id: "CL" },
    "BO": { name: "Bolivia", id: "BO" },
    "SV": { name: "El Salvador", id: "SV" }
}


export const PHONE_NUMBER_CODES: PhoneNumberCode[] = [
    // Latin America
    { code: '+51', en: 'Pe', es: 'Pe' },
    { code: '+57', en: 'Co', es: 'Co' },
    { code: '+55', en: 'Br', es: 'Br' },
    { code: '+52', en: 'Me', es: 'Me' },
    { code: '+54', en: 'Ar', es: 'Ar' },
    { code: '+56', en: 'Ch', es: 'Ch' },
    // { code: '+593', en: 'Ec', es: 'Ec' },
    // { code: '+58', en: 'Ve', es: 'Ve' },
    { code: '+591', en: 'Bo', es: 'Bo' },
    { code: '+503', en: 'Sv', es: 'Sv' },

    // North America
    // { code: '+1', en: 'US', es: 'US' },
    // { code: '+1', en: 'Ca', es: 'Ca' },
    // { code: '+52', en: 'Me', es: 'Me' },
    
    // Europe
    // { code: '+44', en: 'UK', es: 'UK' },
    // { code: '+353', en: 'Ir', es: 'Ir' },
    // { code: '+39', en: 'It', es: 'It' },
    // { code: '+33', en: 'Fr', es: 'Fr' },
    // { code: '+49', en: 'Ge', es: 'Ge' },
    // { code: '+34', en: 'Es', es: 'Es' },
    // { code: '+351', en: 'Po', es: 'Po' },
    // { code: '+31', en: 'Ne', es: 'Ne' },
    // { code: '+32', en: 'Be', es: 'Be' },
    // { code: '+41', en: 'Sw', es: 'Sw' },
    // { code: '+43', en: 'Au', es: 'Au' },
    // { code: '+46', en: 'Sw', es: 'Sw' },
    // { code: '+47', en: 'No', es: 'No' },
    // { code: '+45', en: 'De', es: 'De' },
    // { code: '+358', en: 'Fi', es: 'Fi' },
    // { code: '+48', en: 'Po', es: 'Po' },
    // { code: '+30', en: 'Gr', es: 'Gr' },
    // { code: '+7', en: 'Ru', es: 'Ru' },
    // { code: '+380', en: 'Uk', es: 'Uk' },
    // { code: '+90', en: 'Tu', es: 'Tu' },
    
    // Asia
    // { code: '+81', en: 'Japan', es: 'Japón' },
    // { code: '+86', en: 'China', es: 'China' },
    // { code: '+82', en: 'South Korea', es: 'Corea del Sur' },
    // { code: '+91', en: 'India', es: 'India' },
    // { code: '+65', en: 'Singapore', es: 'Singapur' },
    // { code: '+60', en: 'Malaysia', es: 'Malasia' },
    // { code: '+66', en: 'Thailand', es: 'Tailandia' },
    // { code: '+84', en: 'Vietnam', es: 'Vietnam' },
    // { code: '+62', en: 'Indonesia', es: 'Indonesia' },
    // { code: '+63', en: 'Philippines', es: 'Filipinas' },
    
    // Middle East
    // { code: '+966', en: 'Saudi Arabia', es: 'Arabia Saudita' },
    // { code: '+971', en: 'UAE', es: 'Emiratos Árabes Unidos' },
    // { code: '+972', en: 'Israel', es: 'Israel' },
    
    // Africa
    // { code: '+27', en: 'South Africa', es: 'Sudáfrica' },
    // { code: '+234', en: 'Nigeria', es: 'Nigeria' },
    // { code: '+254', en: 'Kenya', es: 'Kenia' },
    // { code: '+20', en: 'Egypt', es: 'Egipto' },
    // { code: '+212', en: 'Morocco', es: 'Marruecos' },
    
    // Oceania
    // { code: '+61', en: 'Australia', es: 'Australia' },
    // { code: '+64', en: 'New Zealand', es: 'Nueva Zelanda' }
]

export const DEFAULT_PHONE_CODE = { 
    code: '+51', 
    en: 'Perú', 
    es: 'Perú' 
}